<div class="mat-elevation-z5">
  <mat-toolbar color="primary">
    <mat-icon svgIcon="credit-card"></mat-icon>
    <h1 class="mat-title">Factuur betaling</h1>
  </mat-toolbar>
  <div class="mat-body">
    <!-- old code start -->
    <table width="100%">
      <tbody>
        <tr>
          <td>Factuur</td>
          <td class="align-right">{{invoice.number}}</td>
        </tr>
        <tr>
          <td>Datum</td>
          <td class="align-right">{{invoice.date | date: 'dd-MM-yyyy'}}</td>
        </tr>
        <tr>
          <td>Naam</td>
          <td class="align-right">
            <uf-core-relation [relation]="relation"></uf-core-relation>
          </td>
        </tr>
        <tr>
          <td>Totaal bedrag</td>
          <td class="align-right">{{invoice.amount | number: '1.2-2'}}</td>
        </tr>
        @if (invoice.payedAmount !== 0) {
          <tr>
            <td>Betaald</td>
            <td class="align-right">{{invoice.payedAmount | number: '1.2-2'}}
            op {{invoice.payedDate | date: 'dd-MM-yyyy'}}</td>
          </tr>
        }
        <tr>
          <td class="md-subtitle">Openstaand</td>
          <td class="align-right uf-choose-amount" (click)="onSetAmountLeft()">{{amountLeft | number: '1.2-2'}}</td>
        </tr>
      </tbody>
    </table>

    <div class="mat-title" style="border-top: 2px solid #ddd; margin-top: 8px; padding-top:8px;">Nieuwe betaling</div>
    <form [formGroup]="paymentForm">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Betaaldatum</mat-label>
          <input matInput [matDatepicker]="myDatepicker" formControlName="date">
          <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #myDatepicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Bedrag</mat-label>
          <input matInput type="number" placeholder="Bedrag" formControlName="amount" />
        </mat-form-field>
      </div>
    </form>

    @if (paymentForm.controls['amount'].value) {
      <div>
        Openstaand na deze betaling: {{amountLeftAfterPayment | number: '1.2-2'}}
      </div>
    }
    <!-- old code end -->
  </div>
  <div class="uf-action-row">
    <button mat-button mat-raised-button (click)="onCancel()">
      Annuleren
    </button>
    <button mat-button mat-raised-button color="primary" (click)="onPay()">
      Betaald
    </button>
  </div>
</div>






